import Vue from 'vue';
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
import 'muse-ui/dist/theme-carbon.css';
import '@/assets/fonts/fonts.css';

Vue.use(MuseUI);



// WEBPACK FOOTER //
// ./src/plugins/material.js